export default __webpack_public_path__ + "static/media/app-bar-save.fdbe2d97.svg";